export const conventionProvincies = [
  {
    province: "piura-sullana",
    type: "hotel",
    title: 'HOTEL "LA SIESTA"',
    benefits: [
      "10% DE DESCUENTO CON LA PRESENTACIÓN DE SU CIP",
      "ALCANCE:",
      "SOLO EN ALOJAMIENTO (HABITACIONES).",
      " METODOS DE PAGO: EFECTIVO, YAPE, PLIM O TRANSFERENCIAS.",
      " PRESENTACIÓN DE CIP/CIF EN ACTIVIDAD Y/O RETIRO",
      "REQUISITOS:",
      "PERSONAL MILITAR, SERVIDORES PUBLICOS  DEL EJÉRCITO Y FAMILIA MILITAR",
    ],
  },
  {
    province: "piura-sullana",
    type: "restaurant",
    title: "D' PALETAS",
    benefits: [
      "10% DE DESCUENTO CON LA PRESENTACIÓN DE SU CIP",
      "ALCANCE:",
      "CONSUMOS MINIMOS DE S/. 25 EN TODAS NUESTRA CARTAS.",
      "EL DESCUENTO SE APLICA DE LUNES A VIERNES.",
      "NO SE APLICA NI LOS DIAS SÁBADOS, DOMINGOS Y FERIADOS.",
      "MÉTODOS DE PAGO: EFECTIVO, YAPE, PLIM O TRANSFERENCIA.",
      "PRESENTACIÓN DE CIP/CIF EN ACTIVIDAD Y/O RETIRO.",
      "REQUISITOS:",
      "PERSONAL MILITAR, SERVIDORES PUBLICOS  DEL EJÉRCITO Y FAMILIA MILITAR",
    ],
  },
  {
    province: "piura-sullana",
    type: "restaurant",
    title: "DON LIMÓN",
    benefits: [
      "10% DE DESCUENTO CON LA PRESENTACIÓN DE SU CIP",
      "ALCANCE:",
      "SOLO EN COMIDA POR EL CONSUMO MÍNIMO POR EL COMSUMO MÍNIMO DE S/. 100.00.",
      "MÉTODOS DE PAGO: EFECTIVO, YAPE, PLIM, O TRANSFERENCIAS.",
      "PRESENTACIÓN DE CIP/CIF EN ACTIVIDAD Y/O RETIRO",
      "REQUISITOS:",
      "PERSONAL MILITAR, SERVIDORES PUBLICOS  DEL EJÉRCITO Y FAMILIA MILITAR",
    ],
  },
  {
    province: "piura-sullana",
    type: "restaurant",
    title: "SAINT ROSE",
    benefits: [
      "10% DE DESCUENTO CON LA PRESENTACIÓN DE SU CIP",
      "ALCANCE:",
      "SOLO EN COMIDA POR EL CONSUMO MÍNIMO POR EL COMSUMO MÍNIMO DE S/. 100.00.",
      "MÉTODOS DE PAGO: EFECTIVO, YAPE, PLIM, O TRANSFERENCIAS.",
      "PRESENTACIÓN DE CIP/CIF EN ACTIVIDAD Y/O RETIRO",
      "REQUISITOS:",
      "PERSONAL MILITAR, SERVIDORES PUBLICOS  DEL EJÉRCITO Y FAMILIA MILITAR",
    ],
  },
  {
    province: "piura-sullana",
    type: "restaurant",
    title: 'CHIFA RESTAURANTE "WONG SEN"',
    benefits: [
      "10% DE DESCUENTO CON LA PRESENTACIÓN DE SU CIP",
      "ALCANCE:",
      "DESCUENTO EN CONSUMO DE COMIDA Y TODO TIPO DE BEBIDAS, POR EL CONSUMO MINIMO DE S/. 50.00.",
      "MÉTODOS DE PAGO: EFECTIVO, YAPE, PLIM O TRANSFERENCIAS.",
      "PRESENTACIÓN DE CIP/CIF EN ACTIVIDADES Y/O RETIRO.",
      "REQUISITOS:",
      "PERSONAL MILITAR, SERVIDORES PUBLICOS  DEL EJÉRCITO Y FAMILIA MILITAR",
    ],
  },
  {
    province: "puno",
    type: "health",
    title: 'CLINICA "SAUCES MEDICAL CENTER"',
    benefits: [
      "10% DE DESCUENTO CON LA PRESENTACIÓN DE SU CIP",
      "ALCANCE:",
      "COSTOS DIFERENCIADOS",
      "REQUISITOS",
      "PERSONAL MILITAR (INCLUYE PERSONAL DE TROPA), SERVIDORES PÚBLICOS  DEL EJÉRCITO Y FAMILIA MILITAR",
    ],
  },
  {
    province: "arequipa",
    type: "cake-shop",
    title: "PASTELERIA MOCCA",
    benefits: [
      "15% DE DESCUENTO CON LA PRESENTACIÓN DE SU CIP",
      "ALCANCE:",
      "DESCUENTOS EN LA ADQUISICION DE PRODUCTOS DE PASTELERIA.",
      "REQUISITOS",
      "PERSONAL MILITAR Y CIVIL EN SITUACION DE ACTIVIDAD Y RETIRO Y FAMILIARES DIRECTOS",
    ],
  },
  {
    province: "arequipa",
    type: "health",
    title: "ASOCIACION PSICOLOGICA UMANOS",
    benefits: [
      "50% DE DESCUENTO CON LA PRESENTACIÓN DE SU CIP",
      "ALCANCE:",
      "DESCUENTO EN CONSULTAS PSICOLÓGICAS Y TERAPIAS.",
      "REQUISITOS",
      "PERSONAL MILITAR Y CIVIL EN SITUACION DE ACTIVIDAD Y RETIRO Y FAMILIARES DIRECTOS",
    ],
  },
  {
    province: "arequipa",
    type: "health",
    title: "CENTRO PSICOLÓGICO PSICOUNE",
    benefits: [
      "50% DE DESCUENTO CON LA PRESENTACIÓN DE SU CIP",
      "ALCANCE:",
      "DESCUENTO EN CONSULTAS PSICOLÓGICAS Y 40 % DE DESCUENTOS EN TERAPIAS.",
      "REQUISITOS",
      "PERSONAL MILITAR Y CIVIL EN SITUACION DE ACTIVIDAD Y RETIRO Y FAMILIARES DIRECTOS",
    ],
  },
  {
    province: "ayacucho",
    type: "hotel",
    title: "HOTEL ALTIPACHA",
    benefits: [
      "60% DE DESCUENTO CON LA PRESENTACIÓN DE SU CIP",
      "ALCANCE:",
      "SOLO EN ALOJAMIENTO (HABITACIONES).    ",
      "REQUISITOS",
      "PERSONAL MILITAR Y FAMILIARES DIRECTOS",
    ],
  },
  {
    province: "chiclayo",
    type: "company",
    title: "EMPRESA AGROINDUSTRIAL HFE. BERRIES PERÚ",
    benefits: [
      "DESCUENTOS PREFERENCIALES",
      "DESARROLLAR TALLERES DE EMPLEABILIDAD QUE LOGREN LA INSERCIÓN LABORAL DEL PERSONAL DE TROPA PRÓXIMO A LICENCIARSE.",
      "OBTENIENDO DE ESTA MANERA QUE NUESTRO PERSONAL ADQUIERA COMPETENCIAS ACORDE AL PERFIL DEL MERCADO LABORAL (DE FORMA GRATUITO)",
      "REQUISITOS",
      "PERSONAL DE TROPA SMV",
    ],
  },
  {
    province: "chiclayo",
    type: "hotel",
    title: 'HOTEL & CASINO" WIN MEIER"',
    benefits: [
      "45%",
      "DESCUENTO EN TARIFAS DE HABITACIÓN EN TODAS LAS TARIFAS INCLUYEN TRASLADO AEROPUERTO-HOTEL, DESAYUNO EN EL RESTAURANTE DEL HOTEL, INTERNET INALÁMBRICO, ESTACIONAMIENTO GRATUITO, ACCESO LIBRE AL BUSINESS CENTER, USO DE PISCINA, ROOM SERVICE (10:30am - 11:00 pm), LAVANDERÍA Y PLANCHADO PREVIA SOLICITUD",
      "REQUISITOS",
      "OFICIALES, TECNICOS Y SUBOFICIALES, EMPLEADOS CIVILES",
    ],
  },
  {
    province: "chiclayo",
    type: "health",
    title: "ASOCIADOS EN SALUD S.A.C.",
    benefits: [
      "DESCUENTOS PREFERENCIALES",
      "20% DE DESCUENTO EN CONSULTA MÉDICA.BRINDAR SERVICIOS DE CONSULTA MÉDICA EN LAS ESPECIALIDADES DE CIRUGÍA GENERAL EN LAS ESPECIALIDADES DE CIRUGÍA GENERAL, CARDIOVASCULAR, GINECOLOGÍA, MEDICINA GENERAL, MEDICINA INTERNA, MEDICINA ESTÉTICA, NEUROLOGÍA, NEUROPEDIATRIA, NEUROCIRUGIA, OFTALMOLOGIA, OTORRINOLOGÍA, ODONTOLOGÍA, PEDIATRÍA, PSICOLOGÍA, REUMATOLOGÍA, TRAUMATOLOGÍA,TERAPIA FISICA Y REHABILITACIÓN\n",
      "20% DE DESCUENTOS EN TARIFAS VIGENTES DE ANATOMÍA PATOLÓGICA, CÁMARA HIPERBÁRICA, DENSITOMETRÍA ÓSEA, ECOGRAFÍA, LABORATORIO CLÍNICO, RAYOS X, TOMOGRAFÍA, TERAPIA FÍSICA Y REHABILITACIÓN.",
      "REQUISITOS",
      "PERSONAL MILITAR Y CIVIL EN SITUACIÓN DE ACTIVIDAD Y RETIRO",
    ],
  },
  {
    province: "chiclayo",
    type: "health",
    title: "HOSPITAL BELÉN",
    benefits: [
      "DESCUENTOS PREFERENCIALES",
      "ALCANCE",
      "40% DE DESCUENTO PARA EL PERSONAL DE OFICIALES.\n",
      "50% DE DESCUENTO PARA EL PERSONAL DE TECNICOS Y SUBOFICIALES Y SUS FAMILIARES, EMPLEADOS CIVILES,FAMIIARES Y PERSONAL MILITAR EN SITUACION DE RETIRO.\n",
      "FACILIDADES DE PAGO EN FARMACIA EN INTERVENCIONES QUIRURGICAS DE EMERGENCIA.\n",
      "EXONERACION DE PAGOS EN INTERVENCIONES QUIRÚRGICAS DE EMERGENCIA AL PERSONAL DE TROPA SERVICIO MILITAR\n",
      "35% EN ANALISIS DE LABORATORIO.\n",
      "ATENCIÓN DE PACIENTES EN TRABAJOS DE PARTOS DISTÓCICOS.\n",
      "ATENCIÓN PEDIATRICA A LOS HIJOS DE PERSONAL MILITAR Y CIVIL",
      "REQUISITOS:",
      "PERSONAL DE OFICIALES, TECNICOS Y SUB OFICIALES, PERSONAL DE TROPA SMV, PERSONAL CIVIL Y FAMILIARES DIRECTOS DEBIDAMENTE IDENTIFICADOS CON SU CARNET DE IDENTIDAD",
    ],
  },
  {
    province: "huancayo",
    type: "health",
    title: 'CENTRO DE TERAPIA "INFFEL"',
    benefits: [
      "ALCANCE:",
      "SE LE OTORGARA UN DESCUENTO EN CUALQUIERA DE LAS TERAPIAS.",
      "REQUISITOS",
      "PERSONAL MILITAR, CIVIL Y FAMILIARES ",
    ],
  },
  {
    province: "piura-sullana",
    type: "restaurant",
    title: "CHIFA SAN ZI",
    benefits: [
      "DESCUENTOS PREFERENCIALES",
      "ALCANCE:",
      "SE ENCUENTRA UBICADA EN MZ P1 LOTE 19 URBANIZACION JARDÍN 1RA ETAPA",
      "REQUISITOS",
      "PERSONAL MILITAR, SERVIDORES PÚBLICOS  DEL EJÉRCITO Y FAMILIA MILITAR",
    ],
  },
  {
    province: "piura-sullana",
    type: "restaurant",
    title: "RESTAURANT EL LEÑADOR Y ALGO MAS",
    benefits: [
      "DESCUENTOS PREFERENCIALES",
      "ALCANCE:",
      "SE ENCUENTRA UBICADA EN LA CALLE SANTA CLARA N°340 URB SANTA ROSA",
      "REQUISITOS:",
      "PERSONAL MILITAR, SERVIDORES PÚBLICOS  DEL EJÉRCITO Y FAMILIA MILITAR",
    ],
  },
  {
    province: "piura-sullana",
    type: "restaurant",
    title: "MAYU COMIDA Y SALÓN",
    benefits: [
      "DESCUENTOS PREFERENCIALES",
      "ALCANCE:",
      "SE ENCUENTRA UBICADA EN LA CALLE SAN JUAN BOSCO N° 380",
      "REQUISITOS:",
      "PERSONAL MILITAR, SERVIDORES PÚBLICOS  DEL EJÉRCITO Y FAMILIA MILITAR",
    ],
  },
  {
    province: "trujillo",
    type: "hotel",
    title: 'HOTEL "COLONIAL"',
    benefits: [
      "28%",
      "ALCANCE:",
      "DESCUENTO SOLO EN ALOJAMIENTO (HABITACIONES)",
      "METODOS DE PAGO: EFECTIVO, YAPE, PLIM O TRANSFERENCIAS",
      "PRESENTAR CIP/CIF EN ACTIVIDAD Y/O RETIRO.",
      "REQUISITOS:",
      "PERSONAL MILITAR, SERVIDORES PUBLICOS DEL EJÉRCITO Y FAMILIA MILITAR",
    ],
  },
  {
    province: "trujillo",
    type: "hotel",
    title: 'HOTEL "EL BRUJO"',
    benefits: [
      "10%",
      "ALCANCE:",
      "DESCUENTO SOLO EN ALOJAMIENTO (HABITACIONES)",
      "METODOS DE PAGO: EFECTIVO, YAPE, PLIM O TRANSFERENCIAS",
      "PRESENTAR CIP/CIF EN ACTIVIDAD Y/O RETIRO.",
      "REQUISITOS:",
      "PERSONAL MILITAR, SERVIDORES PUBLICOS DEL EJÉRCITO Y FAMILIA MILITAR",
    ],
  },
  {
    province: "trujillo",
    type: "hotel",
    title: 'HOTEL "RADO"',
    benefits: [
      "10%",
      "ALCANCE:",
      "DESCUENTO SOLO EN ALOJAMIENTO (HABITACIONES)",
      "METODOS DE PAGO: EFECTIVO, YAPE, PLIM O TRANSFERENCIAS",
      "PRESENTAR CIP/CIF EN ACTIVIDAD Y/O RETIRO.",
      "REQUISITOS:",
      "PERSONAL MILITAR, SERVIDORES PUBLICOS DEL EJÉRCITO Y FAMILIA MILITAR",
    ],
  },
  {
    province: "trujillo",
    type: "restaurant",
    title: "DANIELITA CEVICHERÍA RESTAURANTE",
    benefits: [
      "15%",
      "ALCANCE:",
      "DESCUENTO EN TODA NUESTRA CARTA",
      "DESCUENTO SE APLICA TODOS LOS DIAS.",
      "METODOS DE PAGO: EFECTIVO, YAPE, PLIM O TRANSFERENCIAS.",
      "PRESENTAR CIP/CIF EN ACTIVIDAD Y/O RETIRO.",
      "REQUISITOS:",
      "PERSONAL MILITAR, SERVIDORES PUBLICOS DEL EJÉRCITO Y FAMILIA MILITAR",
    ],
  },
  // {
  //   province: "tumbes",
  //   type: "hotel",
  //   title: "HOTEL ROMA",
  //   benefits: [
  //     "15%",
  //     "ALCANCE:",
  //     "DESCUENTOS EN TODOS SUS SERVICIOS",
  //     "UBICACIÓN: CALLE GRAU N° 425 PLAZA DE ARMAS DE TUMBES",
  //     "REQUISITOS:",
  //     "PERSONAL MILITAR EN ACTIVIDAD O RETIRO, EMPLEADOS CIVILES Y FAMILIARES DIRECTOS (PADRES DEL TITULAR, ESPOSA E HIJOS)",
  //   ],
  // },
  {
    province: "tumbes",
    type: "hotel",
    title: "HOTEL RESTAURANTE LAS CABAÑAS DE ZORRITOS",
    benefits: [
      "10%",
      "ALCANCE:",
      "DESCUENTO EN PLATOS  A LA CARTA",
      "DESCUENTO EN HABITACIONES.",
      "SE ENCUENTRA UBICADO EN LA AV PANAMERICANA NORTE KM 214.50 BOCAPAN CONTRAALMIRANTE VILLAR ZORRITOS TUMBES",
      "REQUISITOS:",
      "PERSONAL MILITAR EN ACTIVIDAD O RETIRO, PERSONAL CIVIL EN ACTIVIDAD O CESANTE, FAMILIARES DIRECTOS, ESPOSA, HIJOS Y PADRES",
    ],
  },
  {
    province: "tumbes",
    type: "restaurant",
    title: "EL HUERTO DEL SABER",
    benefits: [
      "10%",
      "ALCANCE:",
      "*DESCUENTO EN PLATOS  A LA CARTA PESCADOS, CARNES Y MARISCOS.",
      "SE ENCUENTRA UBICADO EN SAN JUAN DE LA VIRGEN- TUMBES",
      "REQUISITOS:",
      "PERSONAL MILITAR EN ACTIVIDAD O RETIRO, PERSONAL CIVIL EN ACTIVIDAD O CESANTE, FAMILIARES DIRECTOS, ESPOSA, HIJOS Y PADRES",
    ],
  },
  {
    province: "tumbes",
    type: "transport",
    title: "LA COLMENA TOURS",
    benefits: [
      'EMPRESA DE TRANSPORTE TURISTICO "LA COLMENA TOURS" EIRL',
      "20%",
      "ALCANCE:",
      "DESCUENTOS EN TODOS SUS SERVICIOS",
      "REQUISITOS:",
      "PERSONAL MILITAR EN ACTIVIDAD O RETIRO, EMPLEADOS CIVILES Y FAMILIARES DIRECTOS (PADRES DEL TITULAR, ESPOSA E HIJOS)",
    ],
  },
  {
    province: "merced",
    type: "hotel",
    title: "LOS COCOS",
    benefits: [
      'EMPRESA DE TRANSPORTE TURISTICO "LA COLMENA TOURS" EIRL',
      "15%",
      "ALCANCE:",
      "ACCESO A DESCUENTOS EN HABITACIONES",
      "SE ENCUENTRA UBICADO:",
      "Av. Principal S/N, San Ramón 12840",
      "TELEFONO: (064) 333458",
      "REQUISITOS:",
      "PERSONAL MILITAR, CIVIL  Y FAMILIARES DIRECTOS (CÓNYUGE E HIJOS) EN ACTIVIDAD Y RETIRO",
    ],
  },
  {
    province: "merced",
    type: "center-playtime",
    title: "LAS TUTUNAS",
    benefits: [
      "10%",
      "ALCANCE:",
      "ACCESO A DESCUENTOS EN USO DE SUS INSTALACIONES (PISCINA Y CAMPO DEPORTIVO",
      "SE ENCUENTRA UBICADO:",
      "Calle Las Guanábanas s/n Urb., Av. Manuel A. Pinto-La Merced",
      "TELEFONO: 942600089",
      "REQUISITOS:",
      "PERSONAL MILITAR, CIVIL  Y FAMILIARES DIRECTOS (CÓNYUGE E HIJOS) EN ACTIVIDAD Y RETIRO",
    ],
  },
  {
    province: "chiclayo",
    type: "clinic",
    title: "SANTA ANA SALUD",
    benefits: [
      "20%",
      "ALCANCE:",
      "BRINDA SERVICIO DE SALUD ESPECIALIZADA",
      "INCREMENTA SERVICIO DE SALUD ESPECIALIZADA, RESOLVIENDO DE INTEGRAL LOS PROBLEMAS DE SALUD.",
      "RESOLVIENDO DE INTEGRAL LOS PROBLEMAS DE SALUD.",
      "REQUISITOS:",
      "PERSONAL DE OFICIALES, TECNICOS Y SUB OFICIALES, PERSONAL DE TROPA SMV, PERSONAL CIVIL Y FAMILIARES DIRECTOS.",
    ],
  },
  {
    province: "lambayeque",
    type: "gym",
    title: "GIMNASIO WORLD LIGHT",
    benefits: [
      "DESCUENTOS PREFERENCIALES",
      "ALCANCE:",
      "OFRECE TRES (03) DÍAS DE PRUEBA PARA ACUDIR AL GIMNASIO WORLD LIGHT EN CUALQUIERA DE SUS SEDES.  ",
      "DESCUENTO CON EL 30% EN EL PAQUETE COMPLETO OBTENIENDO EL PRECIO DE S/. 90.00 EN LAMBAYEQUE. ",
      "DESCUENTO CON EL 20% OBTENIENDO EL PRECIO DE S/. 150.00 EN LAS SEDES DE CHICLAYO (SANTA VICTORIA, MATÍA IZAGA, SÁENZ PEÑA Y BOLGNESI). ",
      "AREA CARDIOVASCULAR.",
      "ÁREA DE MÁQUINAS.",
      "PROGRAMA DE ENTRANAMIENTO SEMI PERSONALIZADO.",
      "BAILE",
      "CYCLING",
      "CROSSFI",
      "ASESORÍA NUTRICIONAL PERSONALIZADA",
    ],
  },
];
